import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navbarCollapse", "toggler"]

  connect() {
    this._onClick = this.handleDocumentClick.bind(this)
    document.addEventListener('click', this._onClick)
  }

  disconnect() {
    document.removeEventListener('click', this._onClick)
  }

  handleDocumentClick(event) {
    const navbarCollapse = this.navbarCollapseTarget
    const toggler = this.togglerTarget
    const isClickInside = navbarCollapse.contains(event.target) || toggler.contains(event.target)
    if (!isClickInside && navbarCollapse.classList.contains('show')) {
      // Use Bootstrap's Collapse API
      if (window.bootstrap) {
        const collapse = window.bootstrap.Collapse.getOrCreateInstance(navbarCollapse)
        collapse.hide()
      }
    }
  }
} 